import type { MaybeRefOrGetter } from '@vueuse/core';
import type { PopularTitleGraphqlFragment } from '@/pages/graphql/fragments/PopularTitle.fragment';
import type { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';
import type { GetReelTitlesQuery, GetReelTitlesQueryVariables } from './queries/GetReelTitles.query';

import { ReelsExpName, ReelsExpVariants } from '..';
import { GetReelTitlesDocument } from './queries/GetReelTitles.query';

import { useMounted } from '@vueuse/core';
import { useQuery } from '@/helpers/composables/useApollo';
import { useExperimentStore } from '@/helpers/composables/useStores';

import { toValue } from '@vueuse/core';
import { computed } from 'vue';
import { useUserAgent } from '@/helpers/composables/useUserAgent';

export type ReelTitles = NonNullable<GetReelTitlesQuery['popularTitles']['edges']>[number];

export function useReels(queryVariables: MaybeRefOrGetter<GetPopularTitlesQueryVariables>) {
	const { activeReelExpVariant } = useReelsExp();

	const reelsQueryVariables = computed(() => {
		const mVariables = toValue(queryVariables);
		const variables = structuredClone(mVariables);

		variables.popularTitlesFilter = {
			...variables.popularTitlesFilter,
			clipType: 'vertical',
			clipTechnicalProvider: 'dailymotion',
		};

		return variables;
	});

	const { result, loading, fetchMore } = useQuery<GetReelTitlesQuery, GetReelTitlesQueryVariables>(
		GetReelTitlesDocument,
		reelsQueryVariables,
		{ fetchPolicy: 'cache-and-network' }
	);

	const reelsCount = computed(() => {
		return 0;
		// return result.value?.popularTitles.totalCount ?? 0
	});
	const reelTitles = computed(() => result.value?.popularTitles.edges ?? []);

	function fetchMoreReels() {
		if (!result.value?.popularTitles.pageInfo.hasNextPage) return;

		const after = result.value?.popularTitles?.pageInfo.endCursor;

		fetchMore({
			variables: { after },
			updateQuery(previousResult, { fetchMoreResult }) {
				if (!fetchMoreResult) return previousResult;

				return {
					popularTitles: {
						__typename: previousResult.popularTitles.__typename,
						pageInfo: fetchMoreResult.popularTitles.pageInfo,
						totalCount: fetchMoreResult.popularTitles.totalCount,
						edges: [
							...(previousResult.popularTitles.edges ?? []),
							...(fetchMoreResult?.popularTitles.edges ?? []),
						],
					},
				};
			},
		});
	}

	return {
		loading,
		reelsCount,
		reelTitles,
		fetchMoreReels,

		activeReelExpVariant,
	};
}

export function useReelsExp() {
	const isMounted = useMounted();
	const experimentStore = useExperimentStore();
	const { deviceOs } = useUserAgent();

	/**
	 * Returns the active variant or undefined if
	 * - user is on iOS
	 * - app isn't mounted
	 * - not in experiment
	 */
	const activeReelExpVariant = computed(() => {
		return undefined;
		// if (!isMounted.value || deviceOs.value === 'ios') return undefined;

		// return experimentStore.activeVariantsWithControlGroup.value[ReelsExpName] as ReelsExpVariants;
	});

	return {
		activeReelExpVariant,
	};
}

export function getClipFromMovieOrShow(title: PopularTitleGraphqlFragment) {
	return (title?.content.dailymotionClips ?? []).find(clip => clip.streamUrl != null)?.streamUrl ?? null;
}
